module.exports = __webpack_public_path__ + "static/media/play-store-cache-en.1a79e35f.png";